import * as Yup from 'yup';
import { FeedbackReasonValues } from '../enums/FeedbackReasonsValues';

const EMPTY_FIELD_ERROR_TEXT = 'Required field';

const fieldsSchema = {
  feedbackText: Yup.string().required(EMPTY_FIELD_ERROR_TEXT),
  feedbackReason: Yup.string().required(EMPTY_FIELD_ERROR_TEXT),
  summary: Yup.string().when('feedbackReason', {
    is: FeedbackReasonValues.Other,
    then: (schema) => schema.required(EMPTY_FIELD_ERROR_TEXT),
    otherwise: (schema) => schema.optional(),
  }),
};

export const validationSchema = Yup.object().shape(fieldsSchema);
